import moment from "moment/moment";

export default class TaskModel {
  constructor(data) {
    this.id = data.id;
    this.task_type = data.task_type || null;
    this.task_sub_type = data.task_sub_type || null;
    this.user_status = data.user_status || null;
    this.priority_type = data.priority_type || null;
    this.from_user = data.from_user || {};
    this.to_user = data.to_user || {};
    this.content = data.content || "";
    // this.due_date = data.due_date || null;
    this.start_time = data.start_time || null;
    this.end_time = data.end_time || null;
    this.main_task_id = data.main_task_id || null;
    this.main_id = data.main_id || null;
    this.sub_task_pos_id = data.sub_task_pos_id || null;
    this.time_quantity = data.time_quantity || null;
    this.created_at = data.created_at || null;
    this.updated_at = data.updated_at || null;
    this.log = data.log || [];
    this.reply = data.reply || [];
    this.task_assignment = data.task_assignment || [];
    this.task_assignment_log = data.task_assignment_log || [];
    this.transfer = data.task_transfers || [];
    this.task_comp_confirmation = data.task_comp_confirmation || [];
    this.task_read_only = data.task_read_only || [];
    this.task_check = data.task_check || [];
    this.task_time_duration = data.task_time_duration || [];
    this.task_time_duration_log = data.task_time_duration_log || [];
    this.task_view_log = data.task_view_log || [];
    this.taskSubStatus = data.task_sub_status || [];
    this.categories = data.categories || [];
    this.sub_task_assignment = data.sub_task_assignment || [];
    this.task_conversation_count = data.task_conversation_count || [];
    this.optout = data.optout || [];
    this.real_task_main_id = data.real_task_main_id || [];
    this.sub_tasks = data.sub_tasks || [];
    this.task_process_log = data.task_process_log || [];
    this.not_approved_rating = data.not_approved_rating || null;
    this.task_location = data.task_location || null;
    let now = moment();

    /*    if (now.isAfter(moment(this.due_date))
    ) {
      this.missedScheduledCall = true;
    }*/
    //   if (this.status_type.id === 7) {
    //     this.missedScheduledCall = true;
    //   }
    //   if (
    //     now.isBetween(
    //       moment(this.due_date).subtract(15, "minutes"),
    //       moment(this.due_date)
    //     )
    //   ) {
    //     this.scheduledCallSoon = true;
    //   }
  }
}
